import { Redirect } from "react-router";
import Login from "./../pages/user/login.js";
import Register from "./../pages/user/register.js";
import ForgetPassword from "../pages/user/forgetPassword.js";
import ResetPassword from "../pages/user/resetPassword.js";

const UnauthorizeRoute = [
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/user/login" />,
  },
  {
    path: "/user/login",
    title: "Login",
    component: Login,
  },
  {
    path: "/user/register",
    title: "Register",
    component: Register,
  },
  {
    path: "/user/forgetPassword",
    title: "Forget Password",
    component: ForgetPassword,
  },
  {
    path: "/user/resetPassword/:token",
    title: "Reset Password",
    component: ResetPassword,
  },
  {
    path: "*",
    component: () => <Redirect to="/user/login" />,
  },
];

export default UnauthorizeRoute;
